/**
 * Phase F / C-3 — Shared UI timing constants.
 *
 * Single source of truth for the two timings the orientation surfaces
 * share: hover-tooltip appear delay (Q3b) and loading-message rotation
 * interval (Q3d + Q34).
 *
 * Per Q34 the module is intentionally narrow: ONLY these two values.
 * Other UI timing (animation curves, fade durations, etc.) lives with
 * the surface that owns it.
 *
 * Plan: ~/.claude/plans/it-s-time-to-rustling-locket.md §"Phase F" + C-3.
 */

/**
 * Hover delay before a tooltip appears, in milliseconds. Per Q3b the
 * value is configurable from one place so a future tone-pass can
 * lengthen / shorten without touching every component.
 *
 * 250ms matches the user's explicit "at least 250ms" guidance and the
 * browser-default `title` attribute on most platforms, so HTML
 * `title=`-based tooltips and the styled Tooltip primitive feel
 * uniform.
 */
export const TOOLTIP_DELAY_MS = 250;

/**
 * How often `useLoadingMessage(context)` rotates to the next pool
 * string, in milliseconds. Per Q8 + Q34 every loading-message context
 * shares this single rotation cadence so a lawyer who watches two
 * loaders fire side-by-side sees them tick in unison.
 *
 * 3000ms = roughly one breath; long enough to read a 60-char string,
 * short enough that a 30-second provision sees 10 distinct strings.
 */
export const LOADING_MESSAGE_ROTATION_MS = 3000;
